export default __webpack_public_path__ + "static/media/investment_male.2d9f4000.png";